module.exports = __webpack_public_path__ + "static/media/external-white.00e8cf46.svg";